import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class NatureControle extends IdCodeLibelle {}
